export default import.meta.ROLLDOWN_FILE_URL_4QeQqVAUdwGwQIvMHnqk_g